import {tr} from './locales.js';
export function panelModel(state,lang) {
 const t=(key,values)=>tr(lang,key,values),quiz=['overload','leakage'].includes(state.phase);
 const model={title:t(state.phase+'Title'),body:t(state.phase+'Goal'),feedback:state.feedback?t(state.feedback):'',image:false,buttons:[]};
 if(state.detail && state.detail!=='correct'){
  model.title=t(state.detail);model.body=t(state.detail+'Body');model.image=state.detail==='diagram';
  model.buttons.push({label:t('continue'),action:'continue'});
 }else if(quiz){
  if(state.detail==='correct')model.buttons.push({label:t(state.phase==='overload'?'next':'finish'),action:'continue'});
  else for(const choice of ['breaker','differential'])model.buttons.push({label:t(choice),action:'answer:'+choice});
 }else if(state.phase==='complete'){
  model.title=t('complete');model.body=t('score',{score:state.score})+'\n\n'+t('recap')+'\n\n'+t('completeNote');
  model.buttons.push({label:t('restart'),action:'restart'});
 }
 return model;
}
